import { render, staticRenderFns } from "./ContestResults.vue?vue&type=template&id=68499892&scoped=true&"
import script from "./ContestResults.vue?vue&type=script&lang=js&"
export * from "./ContestResults.vue?vue&type=script&lang=js&"
import style0 from "./ContestResults.vue?vue&type=style&index=0&id=68499892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68499892",
  null
  
)

export default component.exports